var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCriminalDefenceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#B1D7D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_72195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 34H25V38.5H23.5V34Z",
    fill: "#006766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.75 31H21.25C20.6534 30.9994 20.0815 30.7622 19.6597 30.3403C19.2378 29.9185 19.0006 29.3466 19 28.75V20.5H17.5V28.75C17.5012 29.7442 17.8967 30.6973 18.5997 31.4003C19.3027 32.1033 20.2558 32.4988 21.25 32.5H31.75C32.2964 32.5024 32.8355 32.6256 33.3287 32.8608L28.75 37.4395L29.8105 38.5L34.5408 33.7698C35.1552 34.4501 35.4968 35.3333 35.5 36.25V38.5H37V36.25C36.9984 34.8581 36.4448 33.5237 35.4606 32.5394C34.4763 31.5552 33.1419 31.0016 31.75 31Z",
    fill: "#006766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9562 19.0293L29.7062 17.5293C29.5714 17.4907 29.4285 17.4907 29.2937 17.5293L24.0437 19.0293C23.8569 19.0828 23.6981 19.2068 23.6008 19.3751C23.5036 19.5434 23.4755 19.7429 23.5225 19.9315L24.25 22.8423V24.25C24.25 24.9394 24.3858 25.6221 24.6496 26.2591C24.9134 26.8961 25.3002 27.4748 25.7877 27.9623C26.2752 28.4498 26.8539 28.8365 27.4909 29.1004C28.1278 29.3642 28.8105 29.5 29.5 29.5C30.1894 29.5 30.8721 29.3642 31.5091 29.1004C32.146 28.8365 32.7248 28.4498 33.2123 27.9623C33.6998 27.4748 34.0865 26.8961 34.3503 26.2591C34.6142 25.6221 34.75 24.9394 34.75 24.25V22.8423L35.4775 19.9323C35.5247 19.7435 35.4967 19.5438 35.3994 19.3754C35.3022 19.2069 35.1433 19.0828 34.9562 19.0293ZM29.5 19.03L33.8462 20.272L33.415 22H30.25V20.5H28.75V22H25.5857L25.1537 20.272L29.5 19.03ZM29.5 28C28.5058 27.9988 27.5526 27.6033 26.8496 26.9003C26.1466 26.1973 25.7512 25.2442 25.75 24.25V23.5H33.25V24.25C33.2488 25.2442 32.8533 26.1973 32.1503 26.9003C31.4473 27.6033 30.4942 27.9988 29.5 28Z",
    fill: "#006766"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E0EFEF",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_72195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriminalDefenceIcon);
export default __webpack_public_path__ + "static/media/criminal-defence-icon.f98c561967175d34d47260b0357f8cc8.svg";
export { ForwardRef as ReactComponent };